export const palette = {
  darkblack: {
    100: "#000000",
    80: "rgba(0, 0, 0, 0.8)",
    60: "rgba(0, 0, 0, 0.6)",
    40: "rgba(0, 0, 0, 0.4)",
    20: "rgba(0, 0, 0, 0.2)",
  },
  black: {
    100: "#090B1F",
    80: "rgba(9, 11, 31, 0.8)",
    60: "rgba(9, 11, 31, 0.6)",
    40: "rgba(9, 11, 31, 0.4)",
    20: "rgba(9, 11, 31, 0.2)",
  },
  white: {
    100: "#FFFFFF",
    80: "rgba(255, 255, 255, 0.8)",
    60: "rgba(255, 255, 255, 0.6)",
    40: "rgba(255, 255, 255, 0.4)",
    20: "rgba(255, 255, 255, 0.2)",
  },
  ebb: {
    100: "#F4F1F2",
    80: "rgba(244, 241, 242, 0.8)",
    60: "rgba(244, 241, 242, 0.6)",
    40: "rgba(244, 241, 242, 0.4)",
    20: "rgba(244, 241, 242, 0.2)",
  },
  teal: {
    100: "#59968A",
    80: "rgba(89, 150, 138, 0.8)",
    60: "rgba(89, 150, 138, 0.6)",
    40: "rgba(89, 150, 138, 0.4)",
    20: "rgba(89, 150, 138, 0.2)",
  },
  beige: {
    100: "#FFF3E0",
    80: "rgba(255, 243, 224, 0.8)",
    60: "rgba(255, 243, 224, 0.6)",
    40: "rgba(255, 243, 224, 0.4)",
    20: "rgba(255, 243, 224, 0.2)",
  },
  darkgray: {
    100: "#3A3C4C",
    80: "rgba(58, 60, 75, 0.8)",
    60: "rgba(58, 60, 75, 0.6)",
    40: "rgba(58, 60, 75, 0.4)",
    20: "rgba(58, 60, 75, 0.2)",
  },
  manhattan: {
    100: "#F7B696",
    80: "rgba(247, 182, 150, 0.8)",
    60: "rgba(247, 182, 150, 0.6)",
    40: "rgba(247, 182, 150, 0.4)",
    20: "rgba(247, 182, 150, 0.2)",
  },
  pink: {
    100: "#ECAEB0",
    80: "rgba(236, 174, 176, 0.8)",
    60: "rgba(236, 174, 176, 0.6)",
    40: "rgba(236, 174, 176, 0.4)",
    20: "rgba(236, 174, 176, 0.2)",
  },
  green: {
    100: "#00FF00",
    80: "rgba(0, 255, 0, 0.8)",
    60: "rgba(0, 255, 0, 0.6)",
    40: "rgba(0, 255, 0, 0.4)",
    20: "rgba(0, 255, 0, 0.2)",
  },
  jungle: {
    100: "#2A9D8F",
    80: "rgba(42, 157, 143, 0.8)",
    60: "rgba(42, 157, 143, 0.6)",
    40: "rgba(42, 157, 143, 0.4)",
    20: "rgba(42, 157, 143, 0.2)",
  },
  lightbrown: {
    100: "#CD8054",
    80: "rgba(205, 128, 84, 0.8)",
    60: "rgba(205, 128, 84, 0.6)",
    40: "rgba(205, 128, 84, 0.4)",
    20: "rgba(205, 128, 84, 0.2)",
    10: "rgba(205, 128, 84, 0.1)",
  },
  rose: {
    100: "#B85D5D",
    80: "rgba(184, 93, 93, 0.8)",
    60: "rgba(184, 93, 93, 0.6)",
    40: "rgba(184, 93, 93, 0.4)",
    20: "rgba(184, 93, 93, 0.2)",
  },
  blue: {
    100: "#2F68A1",
    80: "rgba(47, 104, 161, 0.8)",
    60: "rgba(47, 104, 161, 0.6)",
    40: "rgba(47, 104, 161, 0.4)",
    20: "rgba(47, 104, 161, 0.2)",
  },
  rust: {
    100: "#B15239",
    80: "rgba(177, 82, 57, 0.8)",
    60: "rgba(177, 82, 57, 0.6)",
    40: "rgba(177, 82, 57, 0.4)",
    20: "rgba(177, 82, 57, 0.2)",
  },
  mahogany: {
    100: "#A23737",
    80: "rgba(162, 55, 55, 0.8)",
    60: "rgba(162, 55, 55, 0.6)",
    40: "rgba(162, 55, 55, 0.4)",
    20: "rgba(162, 55, 55, 0.2)",
    10: "rgba(162, 55, 55, 0.1)",
  },
  burgundy: {
    100: "#7B1C1C",
    80: "rgba(123, 28, 28, 0.8)",
    60: "rgba(123, 28, 28, 0.6)",
    40: "rgba(123, 28, 28, 0.4)",
    20: "rgba(123, 28, 28, 0.2)",
  },
  red: {
    100: "#ff0000",
    80: "rgba(255, 0, 0, 0.8)",
    60: "rgba(255, 0, 0, 0.6)",
    40: "rgba(255, 0, 0, 0.4)",
    20: "rgba(255, 0, 0, 0.2)",
  },
  steel: {
    100: "#222335",
    80: "rgba(34, 35, 53, 0.8)",
    60: "rgba(34, 35, 53, 0.6)",
    40: "rgba(34, 35, 53, 0.4)",
    20: "rgba(34, 35, 53, 0.2)",
  },
  gray: {
    100: "#535462",
    80: "rgba(83, 84, 98, 0.8)",
    60: "rgba(83, 84, 98, 0.6)",
    40: "rgba(83, 84, 98, 0.4)",
    20: "rgba(83, 84, 98, 0.2)",
  },
  pesto: {
    100: "#8B7630",
    80: "rgba(139, 118, 48, 0.8)",
    60: "rgba(139, 118, 48, 0.6)",
    40: "rgba(139, 118, 48, 0.4)",
    20: "rgba(139, 118, 48, 0.2)",
  },
  stone: {
    100: "#14283F",
    80: "rgba(20, 40, 63, 0.8)",
    60: "rgba(20, 40, 63, 0.6)",
    40: "rgba(20, 40, 63, 0.4)",
    20: "rgba(20, 40, 63, 0.2)",
  },
  xanadu: {
    100: "#748C78",
    80: "rgba(116, 140, 120, 0.8)",
    60: "rgba(116, 140, 120, 0.6)",
    40: "rgba(116, 140, 120, 0.4)",
    20: "rgba(116, 140, 120, 0.2)",
  },
  alto: {
    100: "#D9D9D9",
    80: "rgba(217, 217, 217, 0.8)",
    60: "rgba(217, 217, 217, 0.6)",
    40: "rgba(217, 217, 217, 0.4)",
    20: "rgba(217, 217, 217, 0.2)",
  },
  mercury: {
    100: "#E8E8E8",
    80: "rgba(243, 243, 244, 0.8)",
    60: "rgba(243, 243, 244, 0.6)",
    40: "rgba(243, 243, 244, 0.4)",
    20: "rgba(243, 243, 244, 0.2)",
  },
  acapulco: {
    100: "#7AABA1",
    80: "rgba(122, 171, 161, 0.8)",
    60: "rgba(122, 171, 161, 0.6)",
    40: "rgba(122, 171, 161, 0.4)",
    20: "rgba(122, 171, 161, 0.2)",
  },
  opal: {
    100: "#ACCBC5",
    80: "rgba(172, 203, 197, 0.8)",
    60: "rgba(172, 203, 197, 0.6)",
    40: "rgba(172, 203, 197, 0.4)",
    20: "rgba(172, 203, 197, 0.2)",
  },
  santafe: {
    100: "#BB6852",
    80: "rgba(187, 104, 82, 0.8)",
    60: "rgba(187, 104, 82, 0.6)",
    40: "rgba(187, 104, 82, 0.4)",
    20: "rgba(187, 104, 82, 0.2)",
  },
  skyblue: {
    100: "#97B3D0",
    80: "rgba(151, 179, 208, 0.8)",
    60: "rgba(151, 179, 208, 0.6)",
    40: "rgba(151, 179, 208, 0.4)",
    30: "rgba(151, 179, 208, 0.3)",
    20: "rgba(151, 179, 208, 0.2)",
  },
  manatee: {
    100: "#898A94",
    80: "rgba(137, 138, 148, 0.8)",
    60: "rgba(137, 138, 148, 0.6)",
    40: "rgba(137, 138, 148, 0.4)",
    20: "rgba(137, 138, 148, 0.2)",
  },
  gunpowder: {
    100: "#454655",
    80: "rgba(69, 70, 85, 0.8)",
    60: "rgba(69, 70, 85, 0.6)",
    40: "rgba(69, 70, 85, 0.4)",
    20: "rgba(69, 70, 85, 0.2)",
  },
  poloblue: {
    100: "#97B3D0",
    80: "rgba(151, 179, 208, 0.8)",
    60: "rgba(151, 179, 208, 0.6)",
    40: "rgba(151, 179, 208, 0.4)",
    20: "rgba(151, 179, 208, 0.2)",
  },
  lightgreen: {
    100: "#C0DAD5",
    80: "rgba(192, 218, 213, 0.8)",
    60: "rgba(192, 218, 213, 0.6)",
    40: "rgba(192, 218, 213, 0.4)",
    20: "rgba(192, 218, 213, 0.2)",
    10: "rgba(192, 218, 213, 0.1)",
  },
  space: {
    100: "#222727",
    80: "rgba(34, 39, 39, 0.8)",
    60: "rgba(34, 39, 39, 0.6)",
    40: "rgba(34, 39, 39, 0.4)",
    20: "rgba(34, 39, 39, 0.2)",
  },
  desertstorm: {
    100: "#F9F9F7",
    80: "rgba(249, 249, 247, 0.8)",
    60: "rgba(249, 249, 247, 0.6)",
    40: "rgba(249, 249, 247, 0.4)",
    20: "rgba(249, 249, 247, 0.2)",
  },
  peach: {
    100: "#FFAC7D",
    80: "rgba(255, 172, 125, 0.8)",
    60: "rgba(255, 172, 125, 0.6)",
    40: "rgba(255, 172, 125, 0.4)",
    20: "rgba(255, 172, 125, 0.2)",
  },
  transparent: "transparent",
} as const;
